import { render } from "./App.vue?vue&type=template&id=329c24d8&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=329c24d8&lang=scss"
import "./App.vue?vue&type=style&index=1&id=329c24d8&lang=scss&scoped=true"

import exportComponent from "/src/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329c24d8"]])

export default __exports__